<form class="w-100" name="login" (ngSubmit)="onSubmit()" method="get" accept-charset="utf-8">
  <div class="container-fluid">
    <p>
      We are updating our account security. As part of our ongoing focus on keeping your account secure, SCOHR is implementing strong password requirements enhancements. Please use the Forgot Password to update your password. Thank you.
    </p>
  </div>
  @if (loginLoading == false) {
    <div class="container-fluid">
      @if (error != null && error != '') {
        <div class="row justify-content-center">
          <div class="text-danger">{{error}}</div>
        </div>
      }
      <div class="row justify-content-center">
        <div class="input-group mb-3 col-lg-6">
          <div class="input-group-prepend">
            <span class="input-group-text" id="basic-addon1">Username</span>
          </div>
          <input [(ngModel)]="user.Username" type="text" class="form-control" aria-label="Username"
            aria-describedby="basic-addon1" name="username">
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="input-group col-lg-6">
            <div class="input-group-prepend">
              <span class="input-group-text" id="basic-addon2" style="padding-left: 1em; padding-right: 1em">Password</span>
            </div>
            <input [(ngModel)]="user.Password" type="password" class="form-control"
              aria-label="Password" aria-describedby="basic-addon2" name="password">
              <div class="input-group-append">
                <button role="button" aria-label="Login" class="btn btn-outline-primary" type="submit"
                  id="button-addon2">
                  Login
                </button>
              </div>
            </div>
          </div>
          <div class="row justify-content-center mb-3 ">
            <!--<button type="button" aria-label="Forgot Password" class="btn btn-link text-primary"
            (click)="forgotPassword()">
            Forgot Password
          </button>-->
          <button type="button" aria-label="Forgot Password" class="btn btn-link text-primary"
            (click)="forgotPassword2()">
            Forgot Password
          </button>
        </div>
      </div>
    }
    @if (loginLoading) {
      <div class="d-flex flex-column justify-content-center">
        <div class="spinner-border my-3 mx-auto" role="status"></div>
        <div class="mx-auto">
          <p>Checking credentials...</p>
        </div>
      </div>
    }

  </form>
  <app-forgot-modal #yourForgotModal></app-forgot-modal>
